import { useSelector } from "react-redux"
import { SLICE_AUTH } from "src/redux-app/slices"
import { EstadoServidorDtSourceImplRest } from "../../data/datasources/EstadoServidorDtSourceImplRest";
import { EstadoServidorRepositoryImpl } from "../../data/repositories/EstadoServidorRepositoryImpl";
import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetEstadoServidoresUseCase } from "../../bussines/useCases/GetEstadoServidoresUseCase";

export const useEstadoServidor = () => {
  const apikey: string | undefined = useSelector((state: any) => state[SLICE_AUTH].usuario.key);
  const conceptosDtSourceGql = new EstadoServidorDtSourceImplRest(apikey ?? '');
  const repository = new EstadoServidorRepositoryImpl(conceptosDtSourceGql);

  const getEstadoServidores = async () => {
    const useCase = new GetEstadoServidoresUseCase(repository);
    const result = await executeUseCase({ input:null, useCase });
    return result;
  };
  return { getEstadoServidores };
}